<template lang="pug">
div(v-if="biz")
  Form(ref="form")
  .section-cell(@click="open")
    .section-title Phone
    .section-content {{ phone | phone }}
    .section-note
      v-icon.mr-2(:color="color", small) {{ icon }}
      span {{ text }}
</template>

<script>
import { mapGetters } from "vuex";
import Form from "./Form";

export default {
  components: { Form },
  data() {
    return { loading: false };
  },
  computed: {
    ...mapGetters(["biz"]),
    phone() {
      if (this.biz?.phones?.length) return this.biz.phones[0].number;
      return null;
    },
    call_online() {
      return this.biz.settings?.call_online == true;
    },
    color() {
      return this.call_online ? "green" : "#6b7280";
    },
    icon() {
      return this.call_online ? "mdi-check" : "mdi-close";
    },
    text() {
      if (this.call_online) return "Call on online orders";
      return "Do not call on online orders";
    },
  },
  methods: {
    open() {
      this.$refs.form.open();
    },
  },
};
</script>

<style lang="sass" scoped>
.section-cell
  display: flex
  flex-direction: column
  cursor: pointer
  &:hover
    .section-title
      color: #3b82f6
.section-title
  font-size: 0.8rem
  font-weight: 500
  margin-bottom: 0.5rem
  color: #6b7280
  cursor: pointer
.section-content
  font-size: 1rem
  font-weight: 500
  color: #111827
.section-note
  font-size: 0.8rem
  color: #6b7280
</style>
